var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChina = function SvgChina(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "China_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 9.09H9.091v181.82h181.818V9.091Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#China_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CE282D",
    d: "M100 190.909c50.207 0 90.909-40.702 90.909-90.909 0-50.208-40.702-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100c0 50.207 40.702 90.909 90.91 90.909"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E30A",
    fillRule: "evenodd",
    d: "m27.701 75.53 5.705-17.698-9.769-7.172a97.533 97.533 0 0 1 2.64-3.856l10.724-.026 5.714-17.367.148-.122 5.722 17.489 18.6.078-15.03 10.968 5.678 17.697-15.048-10.942L27.7 75.53m51.85 9.551 6.288 2.553 4.368-5.201-.47 6.756 6.28 2.544-6.574 1.667-.487 6.687-3.603-5.697-6.548 1.59 4.316-5.159-3.57-5.74m33.997-34.005-6.678-1.172-3.186 5.974-.947-6.686-6.678-1.233 6.078-2.944-.929-6.721 4.725 4.854 6.078-2.935-3.178 5.974 4.715 4.89M99.392 81.365l2.066-6.435-5.462-4.012h6.773l2.093-6.425 2.102 6.426h6.772l-5.444 4.011 2.041 6.435-5.471-3.96-5.47 3.96m-19.495-58.78 6.13 2.866 4.62-4.958-.799 6.72 6.105 2.91-6.617 1.268-.842 6.73-3.3-5.906-6.643 1.234 4.602-4.95-3.256-5.914",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgChina;